import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `<p>Коврик для мыши из синтетической ткани диаметром 19.6см</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
